import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalFunction, SKIP_ERROR_INTERCEPTOR } from '../services/globalFunction';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private globalFunction: GlobalFunction) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Allow skipping this interceptor for specific requests by either:
    //  - setting the context token SKIP_ERROR_INTERCEPTOR to true
    //  - matching the request URL against `skipUrls` patterns below
    const skipUrls: Array<RegExp> = [
      // add patterns here to skip interceptor globally, examples:
      // /\/healthcheck$/, /\/metrics\//
    ];

    // If context token is set to true, skip error handling
    if (req.context.get(SKIP_ERROR_INTERCEPTOR)) {
      return next.handle(req);
    }

    // If URL matches any skip pattern, forward without error handling
    for (const p of skipUrls) {
      if (p.test(req.url)) return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((err: unknown) => {
        // Si el error es 401 (No autorizado), redirigir al login
        console.log('errore', err);

        try {
          this.globalFunction.validateError(err);
        } catch (e) {
          console.error('HttpErrorInterceptor: failed to show notification', e);
        }

        return throwError(() => err);
      }),
    );
  }
}

export const httpErrorInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpErrorInterceptor,
  multi: true,
};
